import { render, staticRenderFns } from "./PidCompareStatusPanel.vue?vue&type=template&id=08ef62df&scoped=true&"
import script from "./PidCompareStatusPanel.vue?vue&type=script&lang=js&"
export * from "./PidCompareStatusPanel.vue?vue&type=script&lang=js&"
import style0 from "./PidCompareStatusPanel.vue?vue&type=style&index=0&id=08ef62df&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef62df",
  null
  
)

export default component.exports